module.exports = __webpack_public_path__ + "static/media/toggle_header_icon.6ee030e7.svg";